export function featureFlagLogic({ alternateBehavior, enabledBehavior, isEnabled }) {
  // if the flag is enabled run the enabled behavior
  if (isEnabled) {
    const result = enabledBehavior();

    return result;
  }

  // default for disabled behavior
  let disabledBehavior = () => {};

  // if the flag is disabled run the disabled behavior
  if (alternateBehavior) {
    disabledBehavior = alternateBehavior;
  }

  const result = disabledBehavior();

  return result;
}
